import React, { useEffect } from 'react'
import classNames from 'classnames'
import generalClasses from './Settings.module.css'
import { ValidatedFormInput } from '../../../components/Form/Inputs/Inputs'
import { Button } from '../../../components/Button/Button'
import { Formik } from 'formik'
import { BusinessBasicsSchema } from '../../../util/formSchemas'
import { useDispatch, useSelector } from 'react-redux'
import { userActions, userSelectors } from '../../../redux/userSlice'
import { businessBasicsActions, businessBasicsSelectors } from './basicsSlice'
import notification from '../../../components/Notification/notification'
import { updateBasics } from './basicsApi'
import { UserTypes } from '../../../util/constants'

const BusinessSettingsBasic = () => {
    const dispatch = useDispatch()

    const user = useSelector(userSelectors.userDetails)

    const success = useSelector(businessBasicsSelectors.success)
    const hasError = useSelector(businessBasicsSelectors.hasError)
    const errorMessage = useSelector(businessBasicsSelectors.errorMessage)
    const isFetching = useSelector(businessBasicsSelectors.isFetching)
    const newDetails = useSelector(businessBasicsSelectors.newDetails)

    const handleSubmit = values => {
        notification.loading({
            title: 'Updating details',
        })
        dispatch(updateBasics({ ...user, ...values }))
    }

    useEffect(() => {
        if (!isFetching) {
            notification.destroy()
            if (success) {
                notification.success({
                    title: 'Success!',
                    description: 'Details updated successfully',
                })
                dispatch(userActions.updateDetails({ userDetails: newDetails }))
                dispatch(businessBasicsActions.reset())
            } else if (hasError) {
                notification.failure({
                    title: 'Something went wrong',
                    description: errorMessage,
                })
                dispatch(businessBasicsActions.reset())
            }
        }
    }, [isFetching])

    return (
        <form onSubmit={handleSubmit}>
            <div className={generalClasses.formSection}>
                <div className={generalClasses.formSectionDescription}>
                    <h6 className={generalClasses.formSectionTitle}>Basics</h6>
                    <p className={generalClasses.formSectionSubtitle}>
                        Give a brief description of your company here
                    </p>
                </div>
                <Formik
                    initialValues={{
                        companyname: user.companyname,
                        domainName: user.domainName,
                    }}
                    validationSchema={BusinessBasicsSchema}
                    onSubmit={handleSubmit}
                >
                    {({ handleSubmit }) => (
                        <div className={generalClasses.formSectionInputs}>
                            <div className={generalClasses.formRow}>
                                <ValidatedFormInput
                                    label="Company name"
                                    placeholder="Name of your organization"
                                    name={'companyname'}
                                />
                            </div>
                            <div
                                className={classNames(
                                    generalClasses.formRow,
                                    generalClasses.formRowSpaced
                                )}
                            >
                                <ValidatedFormInput
                                    label="Domain name"
                                    placeholder="Name of your organization"
                                    name={'domainName'}
                                />
                            </div>
                            <div className={generalClasses.formRow}>
                                <Button
                                    type="submit"
                                    className={generalClasses.submitBtn}
                                    bold
                                    onClick={handleSubmit}
                                >
                                    Save
                                </Button>
                            </div>
                        </div>
                    )}
                </Formik>
            </div>
        </form>
    )
}

export default BusinessSettingsBasic
